import { render } from "./CheckerProjectDetails.vue?vue&type=template&id=ef86f1f6"
import script from "./CheckerProjectDetails.vue?vue&type=script&lang=js"
export * from "./CheckerProjectDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__